import BrazilIcon from '../assets/brazil.svg';
import UnitedStatesIcon from '../assets/usa.png';

const countries = [
    { 
        accept_language: 'pt_BR',
        name: 'Brasil', 
        flag: 
            <img 
                src={BrazilIcon} 
                className="country-flag"
                style={{ width: '20px' }} 
            />,
        ddd: '55',
        mask: '(99) 9 9999-9999'
    },
    { 
        accept_language: 'en', 
        name: 'Estados Unidos', 
        flag: 
            <img
             src={UnitedStatesIcon} 
             className="country-flag" 
             style={{ width: '20px' }}
             />,
        ddd: '1',
        mask: '999 999 9999'
    },
];

export{
    countries
}  